import * as React from 'react';
import { useFormContext, Controller, UseControllerReturn } from 'react-hook-form';
import { IIconBaseProps, Label } from '@agilepoint/wat-react-ux';
import { FieldBlock, IBaseFormFieldProps, StyledErrorMessage } from '@agilepoint/wat-react-ux-form-fields';
import { ErrorMessage } from '@hookform/error-message';
import { CustomFileUpload, ICustomFileUploadProps } from '../custom-file-upload';
import { readFileAsDataUrl } from '@agilepoint/utils-common';

export interface ICustomFileUploadField extends IBaseFormFieldProps, Omit<ICustomFileUploadProps, 'multiple' | 'name' | 'label'>, IIconBaseProps { }

export function ImageUploadField(props: ICustomFileUploadField) {
    const { name, className = 'ap-image-upload-field', title, orientation, gap, validationRules, label, onValueChange, iconName, ...restProps } = props;
    const { control, formState: { errors } } = useFormContext();

    const renderFileUpload = React.useCallback(({ field: { onChange, value } }: UseControllerReturn) => {

        const _onValueChange = async (files: File[]) => {
            const [selectedFile] = files;
            const dataURL = await readFileAsDataUrl(selectedFile);
            onChange(dataURL);
        };

        return (
            <CustomFileUpload {...restProps} onValueChange={_onValueChange} iconName={iconName}/>
        );
    }, [iconName, restProps]);

    return (
        <FieldBlock gap={gap} width="auto !important" orientation={orientation} className={className} title={title} >
            {label ? <Label required={validationRules && !!validationRules.required}>{label}</Label> : <></>}
            <Controller control={control} name={name} rules={validationRules} render={renderFileUpload} />
            <ErrorMessage errors={errors} name={name} as={StyledErrorMessage} />
        </FieldBlock >
    );
}
